import { Components } from '@mui/material';

import { DATA_GRID } from './components/dataGrid';
import { MUI_SWITCH } from './components/switch';
import { GLOBALS } from './globals';

export const CUSTOM_OVERRIDES: Components = {
    ...GLOBALS,
    ...DATA_GRID,
    ...MUI_SWITCH,
};
